// imageTokens.js
// Per-image write tokens from the server (#507). The server hands one out when an
// image id is first written; later writes to that id (more chunks, thumbnail,
// clone) must send it back. Kept in localStorage so it survives reloads, like the id.

const KEY = 'mscp_image_tokens';
const MAX_ENTRIES = 50;

function readAll() {
    try {
        const v = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(v) ? v : [];
    } catch (e) {
        return [];
    }
}

const imageTokens = {
    get(id) {
        if (id === undefined || id === null) return '';
        const hit = readAll().find((e) => e[0] === String(id));
        return hit ? hit[1] : '';
    },
    set(id, token) {
        if (id === undefined || id === null || !token) return;
        const rest = readAll().filter((e) => e[0] !== String(id));
        rest.push([String(id), String(token)]);
        try {
            localStorage.setItem(KEY, JSON.stringify(rest.slice(-MAX_ENTRIES)));
        } catch (e) {}
    },
    has(id) {
        return !!this.get(id);
    },
};

export default imageTokens;
